export default {
  CONSULTING_ORTHODONTIST: 'CONSULTING_ORTHODONTIST',
  CLINIC_OWNER: 'CLINIC_OWNER',
  IN_OFFICE_MANUFACTURER: 'IN_OFFICE_MANUFACTURER',
  ALIGNER_COMPANY_OR_LAB: 'ALIGNER_COMPANY_OR_LAB',
  INSTITUTIONS: 'INSTITUTIONS',
  COMMERCIAL_ALIGNER_LAB: 'COMMERCIAL_ALIGNER_LAB',
  CUSTOMER: 'CUSTOMER',
  VENDOR: 'VENDOR',
  ENTERPRISE_COMPANY_LAB: 'ENTERPRISE_COMPANY_LAB',
  INTERNAL_USER: 'INTERNAL_USER',
  GROWTH_CUSTOMER: 'GROWTH_CUSTOMER',
} as const
